import {ButtonProps, ButtonSize, ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./DialogButton.less');
const cx = classnames.bind(styles);

export interface IDialogButtonProps extends ButtonProps
{
    className?:string;
}

export class DialogButton extends React.Component<IDialogButtonProps, any>
{

    public render():JSX.Element
    {
        const {className} = this.props;

        return (
            <WSPButton
                style={ButtonStyle.Raised}
                size={ButtonSize.Large}
                {...this.props}
                className={cx(styles.dialogButton, className)}
            />
        );
    }
}
